export default {
      id: "icon-fax-usage",
      viewBox: "0 0 16.18 14.16",
      url: __webpack_public_path__ + "Assets/Sprite.svg#icon-fax",
      toString: function () {
        return this.url;
      }
    }